import { useQuery } from 'hooks/useCustomQuery';
import getPlatformNumberById from '@/API/PlatformNumber/getPlatformNumberById';

const useCheckCurrentNumber = (
    number,
    setInitialNumber,
    platformId,
    accountScope,
) => {
    return useQuery({
        queryKey: ['checkCurrentNumber', number?.numberID],
        queryFn: async () => {
            try {
                const res = await getPlatformNumberById(
                    number?.numberID,
                    platformId,
                    accountScope,
                );
                setInitialNumber(res || null);

                return res;
            } catch (error) {
                console.error('Error checking number:', error);
                throw error;
            }
        },
        enabled: number?.numberID !== undefined,
        refetchOnWindowFocus: false,
        cacheTime: 0,
        staleTime: 0,
    });
};

export default useCheckCurrentNumber;
